import {IntroductionView} from "@/medication-checkup/interfaces/introduction";
import {SceneProps, useScene} from "@/medication-checkup/composables/useScene";

/**
 * What the scenes of the doorsteps share: the one action that crosses the
 * doorstep, and nothing more.
 *
 * Each step opens on a doorstep — the introduction of the collection, the
 * doorstep of the analysis — and each keeps its own scene, its own place in
 * the course; the mechanic is this one. Everything shown is served by the
 * handler, in `view`: the words and the action while the doorstep has not
 * been crossed, the frozen record afterwards. The scene composes no text of
 * its own. Submitting the clicked action is what crosses it: the server
 * freezes its line and the course moves on, in the same answer.
 *
 * A doorstep is the bare scene, so it adds nothing to the one below it: what
 * lands a beat after the bubble is its quick replies rather than a card.
 */
export const useDoorstepScene = (props: SceneProps<IntroductionView>) => {
    const {bubbleShown, cardShown: repliesShown, clicked, text, actions, acted, act} = useScene(
        props,
        {card: true}
    );

    return {bubbleShown, repliesShown, clicked, text, actions, acted, act};
};
